import React, { useEffect } from 'react';
import entrepreneurship from '../assets/images/entrepreneurship.jpg';
import innovation from '../assets/images/innovation.jpg';
import technology from '../assets/images/technology.jpg';
import marketing from '../assets/images/marketing.jpg';
import { motion } from 'framer-motion';

const services = [
  {
    id: 'its',
    num: '01',
    title: 'Commercial IT Services',
    img: technology,
    description:
      'With our IT services, we specialize in software development, crafting top-notch mobile apps, web apps, and desktop applications. Additionally, we excel in building cutting-edge websites to help businesses thrive in the digital realm.',
    tags: ['Web Development', 'Mobile Apps', 'Desktop Software', 'UI/UX Design'],
    reverse: false,
  },
  {
    id: 'vets',
    num: '02',
    title: 'Vocational & Entrepreneurship Training',
    img: entrepreneurship,
    description:
      "Our entrepreneurship training programs are carefully designed to empower you with the tools and insights necessary to turn your innovative ideas into successful ventures — covering business planning, market analysis, financial management, and strategic decision-making.",
    tags: ['Business Planning', 'Market Analysis', 'Financial Management', 'Strategy'],
    reverse: true,
  },
  {
    id: 'vcs',
    num: '03',
    title: 'Venture Capital Services',
    img: innovation,
    description:
      "At EIT Ghana, we understand that securing funding is often the pivotal point for startups and small businesses to thrive. We've built a strong network of venture capitalists and angel investors passionate about supporting innovative ideas.",
    tags: ['Seed Funding', 'Angel Investment', 'Startup Support', 'Investor Network'],
    reverse: false,
  },
  {
    id: 'mkts',
    num: '04',
    title: 'Marketing Services',
    img: marketing,
    description:
      "At EIT Ghana, we understand the power of effective marketing in driving business success. Our expert team of digital marketing strategists, creative designers, and data analysts craft tailored solutions that align with your unique goals.",
    tags: ['Digital Marketing', 'Creative Design', 'Data Analytics', 'Brand Strategy'],
    reverse: true,
  },
];

export default function Services() {
  useEffect(() => {
    document.title = 'EIT Ghana Limited - Our Services';
  }, []);

  return (
    <motion.div
      className="pt-16 bg-gray-50 min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >

      {/* ── BANNER CARD ── */}
      <section className="pt-8 pb-0">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">
          <motion.div
            className="bg-blueblack rounded-3xl p-10 lg:p-16 relative overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
          >
            <div className="absolute -top-16 -right-16 w-56 h-56 bg-yellowcolor/10 rounded-full" />
            <div className="absolute -bottom-10 right-32 w-36 h-36 bg-seablue/20 rounded-full" />
            <div className="relative z-10 max-w-2xl">
              <p className="text-yellowcolor font-semibold text-xs uppercase tracking-widest mb-4">What We Do</p>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">Our Services</h1>
              <p className="text-gray-300 text-lg leading-relaxed">
                EIT Ghana is a hub that empowers entrepreneurs through training, venture capital services,
                and digital marketing solutions — providing the knowledge, resources, and connections
                necessary for business success.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── SERVICE BENTO CARDS ── */}
      <div className="py-8 pb-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-20 flex flex-col gap-5">
          {services.map(({ id, num, title, img, description, tags, reverse }, i) => (
            <motion.div
              key={id}
              id={id}
              className={`bg-white rounded-3xl overflow-hidden shadow-sm flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {/* Image panel */}
              <div className="w-full lg:w-5/12 overflow-hidden">
                <img
                  src={img}
                  alt={title}
                  className="w-full h-60 lg:h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>

              {/* Text panel */}
              <div className="w-full lg:w-7/12 p-8 lg:p-12 flex flex-col gap-5 justify-center">
                <div className="inline-flex items-center gap-2 bg-blue-50 text-seablue border border-blue-100 px-3 py-1 rounded-full text-xs font-semibold w-fit">
                  Service {num}
                </div>
                <h2 className="text-2xl lg:text-3xl font-bold text-blueblack leading-tight">{title}</h2>
                <p className="text-gray-500 leading-relaxed">{description}</p>
                <div className="flex flex-wrap gap-2">
                  {tags.map(tag => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 bg-gray-50 border border-gray-200 text-blueblack text-xs font-semibold rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

    </motion.div>
  );
}
